export default __webpack_public_path__ + "static/media/cyf_logo.a79342f2.png";